import { useMemo, useRef } from 'react';
import useStateRef from '@web-mail/hooks/useStateRef';
export const useCanUpdate = (sliceId) => {
    const preSliceId = useRef();
    const sliceIdRecordMap = useRef({});
    const canUpdate = useMemo(() => {
        if (sliceId) {
            if (sliceIdRecordMap.current[sliceId]) {
                if (preSliceId.current == sliceId) {
                    return false;
                }
                else {
                    preSliceId.current = sliceId;
                    return true;
                }
            }
            else {
                sliceIdRecordMap.current[sliceId] = 1;
                preSliceId.current = sliceId;
                return true;
            }
        }
        preSliceId.current = sliceId;
        return false;
    }, [sliceId]);
    return useStateRef(canUpdate);
};
